import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box, useMediaQuery, useTheme } from "@mui/material";

interface ILocationsInfoSetupFieldsPanel {
	onLocationsSelectionChangeHandler: (value: any) => void;
	locationsDDLItems: any

}
export const LocationsInfoSetupFieldsPanel: FC<
	ILocationsInfoSetupFieldsPanel
> = ({ onLocationsSelectionChangeHandler,
	locationsDDLItems }) => {
		// RESPONSIVE
		const theme = useTheme();
		const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
		const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
		const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
		return (
			<Box>
				{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
					label="Load Locations"
					selectName="locations"
					testId={`Locations`}
					labelPosition={LabelPosition.Top}
					items={locationsDDLItems ?? []}
					onSelectionChangeHandler={onLocationsSelectionChangeHandler}
					showEmpty
				/>}
				<RHookFormTextFieldWithLabel
					label="Code"
					id="code"
					testId={`code`}
					labelPosition={LabelPosition.Top}
				/>
				<RHookFormTextFieldWithLabel
					label="Name"
					id="locationName"
					testId={`account-title`}
					labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				// required
				/>
				<EnhancedTextAreaFieldRHF
					label="Notes"
					id="notes"
					testId={`notes`}
					// placeholder="Notes"
					labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
				/>
			</Box>
		);
	};
